<script>
    import dressing from "@intellectability/platform-common";

    import {create_security_error} from "@intellectability/platform-common/utils";
    // common constants
    import {ACTIONS} from "@intellectability/platform-common/constants";

    // common components
    import {
        ChoosePersonModal,
        ExportButtons,
        Icon,
        FlexList
    } from "@intellectability/platform-common/sv";

    // bootstrap
    import {
        Breadcrumb,
        BreadcrumbItem,
    } from "@sveltestrap/sveltestrap";

    const {context = "missing ICAP context"} = $props();

    const {
        ICAP_GLOBAL_LIST,
        ICAP_PERSON_LIST,
        ICAP_MANAGE,
        ICAP_DELETE,
        ICAP_PDF
    } = ACTIONS;

    let loading = $state(true);
    let fetchingData = $state(false);
    let isLoggedIn = $state(false);

    /**
     * @type {{
     * userActions: number[]
     * businessRules: BusinessRule[]
     * applicationConfig: {[x: string]: string;}
     * userData: Object|false
     }} */
    let userSecurity = $state.raw({
        userActions: [],
        businessRules: [],
        applicationConfig: {},
        userData: false
    });

    // flexlist data
    /** @type {IcapListEntry[]} */
    let icaps = $state.raw([]);

    // filter options
    let icapSignedBy = $state("");
    let icapDate = $state("");
    let icapScore = $state("");
    let icapMbiScore = $state("");
    let icapsPersonName = $state("");

    // action access
    let canManage = $derived(userSecurity.userActions.includes(ICAP_MANAGE));
    let canDelete = $derived(userSecurity.userActions.includes(ICAP_DELETE));

    // pagination
    let pagination = $state({
        show: true,
        page: 1,
        limit: 10,
        recordsFiltered: -1,
        recordsTotal: -1,
        pageLengthMenu: [10, 25, 50, 100, 500]
    });

    // sort
    /** @type {{field: string, order: 'asc'|'desc'}} */
    let sort = $state({
        field: "name",
        order: "asc"
    });

    $effect( () => {
        if(!loading && isLoggedIn) {
            fetch_filter_list();
        }
    });

    $effect(function load() {
        dressing.api.get_user_security().then(
            (
                response
            ) => {
                if (response.success === true) {
                    const {business_rules, application_config, logged_in_user, logged_in} = response;

                    const securityData = {
                        businessRules: business_rules || [],
                        userActions: logged_in_user.actions || [],
                        applicationConfig: application_config || {},
                        userData: logged_in_user || false,
                    };

                    isLoggedIn = logged_in;

                    // @ts-ignore;
                    userSecurity = securityData;
                    
                    userSecurity.userData = securityData.userData;
                    userSecurity.applicationConfig = securityData.applicationConfig;
                    userSecurity.businessRules = securityData.businessRules;
                    userSecurity.userActions = securityData.userActions;

                    // user requires access to the CASE NOTES LIST (GLOBAL OR PERSON)
                    if (
                        !securityData.userActions.includes(ICAP_GLOBAL_LIST) &&
                        !securityData.userActions.includes(ICAP_PERSON_LIST)
                    ) {
                        const security_error = create_security_error("App.svelte", "Icap",
                        ICAP_PERSON_LIST);
                        dressing.api.report_security_error(security_error);
                    }

                    loading = false;
                }
            }
        );
    });

    function fetch_filter_list() {
        const filter_query = {
            name: icapsPersonName || null,
            icap_date_fmt: icapDate || null,
            icap_score: icapScore || null,
            mbi_score: icapMbiScore || null,
            signed_by_fmt: icapSignedBy || null
        };

        const sort_query = {
            sort: sort.field || null,
            order: sort.order || null
        };

        const page_query = {
            page: pagination.page || null,
            limit: pagination.limit || null
        };
        
        fetchingData = true;

        dressing.get("/cm/icap_forms", {
            params: Object.assign(filter_query, {...sort_query, ...page_query})
        }).then(
            ({data: res}) => {
                if (res.success === true) {
                    const {icaps: array} = res.data;
                    if (Array.isArray(array)) {
                        icaps = array;
                        pagination.recordsFiltered = res.data.recordsFiltered;
                        pagination.recordsTotal = res.data.recordsTotal;
                    }
                }
                fetchingData = false;
            }
        ).catch(function (error) {
            loading = false;
            toast.error("Error fetching ICAPs list");
        });
    }

    /**
     * @param {string} id
     */
    function deleteIcap(id) {
        if (canDelete === true && id.length) {
            loading = true;
            dressing.axi.delete(`/cm/icap_forms/${id}`, {}).then(
                /** @param {{ data: {success:boolean} }} data */({data}) => {
                    if (data.success === true) {
                        fetch_filter_list();
                    }else {
                        toast.error("Error deleting ICAP");
                    }
                }
            ).catch(
                (error) => {
                    console.error("Error deleting ICAP:", error);
                    toast.error("Error deleting ICAP");
                }
            ).finally(() => {
                loading = false;
            });

        }
    }
    
    /**
     * @param {string} id
     */
    function editIcap(id) {
        if (canManage && id.length > 0) {
            window.location.href = `/index.php?action=${ICAP_MANAGE}&id=${id}`;
        }
    }

    /**
     * @param {string} id
     */
    function pdfIcap(id) {
        if (canManage && id.length > 0) {
            window.open(`/index.php?action=${ICAP_PDF}&id=${id}`, "_blank");
        }
    }

    function newIcap(/** @type {{value:string, text:string}} */ person) {
        if (canManage && person?.value.length > 0) {
            dressing.post("/cm/icap_forms/create", {cons_id: person.value})
                .then(({data: res}) => {
                    const {success, data} = res;
                    if (success === true) {
                        const {icap} = data;
                        window.location.href = `/index.php?action=${ICAP_MANAGE}&id=${icap.id}`;
                    }
                }).catch(
                    (error) => {
                        console.error("Error creating new ICAP:", error);
                        toast.error("Error creating new ICAP");
                    }
                );
        }
    }
</script>

<Breadcrumb divider={" "} class="breadcrumbs mb-3">
    <BreadcrumbItem>
        <a href="/index.php?action=30000">
            case management
        </a>
    </BreadcrumbItem>
    <BreadcrumbItem class="mx-3">
        <Icon icon="chevron-right"/>
    </BreadcrumbItem>
    <BreadcrumbItem>
        <Icon icon="warehouse" class="me-2"/>
        icaps
    </BreadcrumbItem>
</Breadcrumb>
<!-- Page Title -->
<h1>
    <Icon icon="warehouse"/>
    ICAPs
</h1>
<!-- Export Buttons -->
<div class="d-flex w-100 justify-content-end mb-3">
    <ExportButtons
            show={["excel", "pdf"]}
            href="ajax/default/ajax.download_list.php?list={ICAP_GLOBAL_LIST}"
    />
</div>
<!-- TABLE -->
<FlexList
        {loading}
        pagerConfig={pagination}
        onpagechange={(/** @type {number} */ page) => (pagination.page = page)}
        onsort={(/** @type {string} */ field, /** @type {'asc'|'desc'} */ order) => {
            sort = { field, order };
        }}
        onpagelengthchange={(/** @type {number} */ newLimit) => (pagination.limit = newLimit)}
        columns={[
            {
                name: "Person",
                field: "name",
                width: "",
                sortedBy: sort.field === "name" ? sort.order : "",
                sortable: true,
                collapse: false,
                filterType: "text",
                filterPlaceholder: "Search",
                onfilter: function (value) {
                    icapsPersonName = value;
                }
            },
            {
                name: "ICAP Date",
                field: "icap_date_fmt",
                width: "",
                sortedBy: sort.field === "icap_date_fmt" ? sort.order : "",
                sortable: true,
                collapse: false,
                filterType: "text",
                filterPlaceholder: "Search",
                onfilter: function (value) {
                    icapDate = value;
                }
            },
            {
                name: "ICAP Score",
                field: "icap_score",
                width: "",
                collapse: false,
                sortedBy: sort.field === "icap_score" ? sort.order : "",
                sortable: true,
                filterType: "text",
                filterPlaceholder: "Search",
                onfilter: function (value) {
                    icapScore = value;
                }
            },
            {
                name: "MBI Score",
                field: "mbi_score",
                width: "",
                sortable: true,
                sortedBy: sort.field === "mbi_score" ? sort.order : "",
                filterType: "text",
                filterPlaceholder: "Search",
                onfilter: function (value) {
                    icapMbiScore = value;
                }
            },
            {
                name: "Signed By",
                field: "signed_by_fmt",
                width: "",
                sortable: true,
                sortedBy: sort.field === "signed_by_fmt" ? sort.order : "",
                filterType: "text",
                filterPlaceholder: "Search",
                onfilter: function (value) {
                    icapSignedBy = value;
                }
            },
            {
                name: "Actions",
                width: "110px",
                buttons: [
                    {
                        icon: "file-pdf",
                        tooltip: "Generate PDF",
                        variant: "neutral",
                        styles: "",
                        action: function (event, row) {
                            const { id } = row;
                            pdfIcap(id);
                        }
                    },
                    {
                        icon: "pencil",
                        tooltip: "Edit",
                        variant: "neutral",
                        styles: "",
                        action: function (event, row) {
                            const { id } = row;
                            editIcap(id);
                        },
                        disable: function (row) {
                            return (row.allow_edit === "Y" && canManage) === false;
                        },
                    },
                    {
                        icon: "times-circle",
                        tooltip: "Delete",
                        variant: "danger",
                        styles: "",
                        action: function (event, row) {
                            const { id } = row;
                            deleteIcap(id);
                        },
                        disable: function (row) {
                            return (row.allow_edit === "Y" && canDelete) === false;
                        },
                    },
                ],
            },
        ]}
        data={icaps}></FlexList>

<div class="mb-5">
    {#if canManage}
        <ChoosePersonModal context="icap" onselect={newIcap} confirmButtonText="Create New ICAP"/>
    {/if}
</div>